import { handleDuration } from 'frontend/utils/helpers';
import React from 'react';
export interface SingleCardMetadataProps {
  duration: number;
  hideCardMetaData?: boolean;
  genre: string;
}
const Duration = ({
  duration
}: {
  duration: number;
}) => {
  const formattedDuration = handleDuration(duration);
  if (formattedDuration) {
    return <span data-exp="card-time">{`${formattedDuration}`}</span>;
  }
};
export const Dot = () => <span data-sentry-component="Dot" data-sentry-source-file="CardMetaData.tsx"> · </span>;
const Episode = ({
  episodeNumber
}: {
  episodeNumber: number;
}) => <span data-exp="card-episode" data-sentry-component="Episode" data-sentry-source-file="CardMetaData.tsx">
    {`Avsnitt ${episodeNumber}`}
    <Dot data-sentry-element="Dot" data-sentry-source-file="CardMetaData.tsx" />
  </span>;
const SeriesTitle = ({
  title
}: {
  title: string;
}) => <span data-exp="card-series" data-sentry-component="SeriesTitle" data-sentry-source-file="CardMetaData.tsx">{`${title}`}</span>;
export const SingleCardMetadata = ({
  duration,
  hideCardMetaData,
  genre
}: SingleCardMetadataProps) => {
  return <>
      <Duration duration={duration} data-sentry-element="Duration" data-sentry-source-file="CardMetaData.tsx" /> <Dot data-sentry-element="Dot" data-sentry-source-file="CardMetaData.tsx" />
      <span>{genre}</span>
      {!hideCardMetaData && <Dot />}
    </>;
};
export const SeriesCardMetadata = ({
  hideCardMetaData = false
}: {
  hideCardMetaData?: boolean;
}) => <span data-sentry-component="SeriesCardMetadata" data-sentry-source-file="CardMetaData.tsx">
    {'Serie'}
    {!hideCardMetaData && <Dot />}
  </span>;
export interface TrailerCardMetadataProps {
  duration: number;
  label: string | null;
  trailingDot: boolean;
}
export const TrailerCardMetadata = ({
  duration,
  label,
  trailingDot
}: TrailerCardMetadataProps) => <>
    {label && <span>
        {label}
        <Dot />
      </span>}
    <Duration duration={duration} data-sentry-element="Duration" data-sentry-source-file="CardMetaData.tsx" />
    {trailingDot && <Dot />}
  </>;
export interface ProgramCardMetadataProps {
  duration: number;
  episodeNumber: number | null;
  isProgramOrSeriesPage?: boolean;
  seriesTitle: string | null;
  trailingDot?: boolean;
  genre: string | null;
}
export const ProgramCardMetadata = ({
  duration,
  episodeNumber,
  isProgramOrSeriesPage = false,
  seriesTitle,
  trailingDot,
  genre
}: ProgramCardMetadataProps) => {
  const programGenre = episodeNumber === null ? genre : null;
  return <>
      {isProgramOrSeriesPage && episodeNumber && <Episode episodeNumber={episodeNumber} />}

      <Duration duration={duration} data-sentry-element="Duration" data-sentry-source-file="CardMetaData.tsx" />
      {programGenre && !episodeNumber && <span>
          <Dot /> {programGenre}
        </span>}

      {!isProgramOrSeriesPage && !programGenre && <>
          <Dot />
          <SeriesTitle title={seriesTitle || ''} />
        </>}

      {trailingDot && <Dot />}
    </>;
};